import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "toast-success",
  class: "flex fixed xs:left-5 top-[85vh] items-center p-4 mb-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-[rgba(17,12,46,0.15)_0px_48px_100px_0px] dark:shadow-[rgba(17,12,46,1)_0px_48px_100px_0px] dark:text-gray-400 dark:bg-gray-800",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_completeToast = _resolveComponent("completeToast")!
  const _component_incompleteToast = _resolveComponent("incompleteToast")!
  const _component_deleteToast = _resolveComponent("deleteToast")!
  const _component_editToast = _resolveComponent("editToast")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mode === 'complete')
          ? (_openBlock(), _createBlock(_component_completeToast, {
              key: 0,
              onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('finish', true)))
            }))
          : (_ctx.mode === 'incomplete')
            ? (_openBlock(), _createBlock(_component_incompleteToast, {
                key: 1,
                onIncomplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('finish', false)))
              }))
            : (_ctx.mode === 'delete')
              ? (_openBlock(), _createBlock(_component_deleteToast, {
                  key: 2,
                  onDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('trash')))
                }))
              : (_ctx.mode === 'edit')
                ? (_openBlock(), _createBlock(_component_editToast, {
                    key: 3,
                    onEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('pencil')))
                  }))
                : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-gray-800 dark:hover:bg-gray-700",
          "data-dismiss-target": "#toast-success",
          "aria-label": "Close",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_4)
      ]))
    : _createCommentVNode("", true)
}